import { ClassName, ListItem } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ReactNode } from 'react';
import './PickerRow.scss';

export interface IPickerRow {
  active: boolean;
  selected?: boolean;
  multiSelect?: boolean;
  onClick: (event: React.MouseEvent) => void;
  children: ReactNode;
  className?: ClassName;
}

export default function PickerRow({ active, selected, multiSelect, children, onClick }: IPickerRow) {
  const classes = classNames('picker-row', { focused: active, selected, 'multi-select': multiSelect });

  return (
    <ListItem className={classes} onClick={onClick}>
      {children}
    </ListItem>
  );
}
